import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolvePageMeta, SeoLanguage } from "../seo/pageMeta";

// Keeps the browser tab title in sync with the current route and language
// on client-side navigations (the initial HTML title is already correct,
// injected server-side - see middleware.ts / server.ts, which read the
// same "/en" URL prefix i18n.ts does).
export function usePageMeta() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang: SeoLanguage = i18n.language.startsWith('en') ? 'en' : 'no';

  useEffect(() => {
    // Article pages (/news/:articleSlug) set their own title/description
    // once the article loads (see NewsPage.tsx) - there's no static entry
    // for them here, so applying the generic fallback would only flash the
    // wrong title before NewsPage overwrites it.
    if (/^\/(en\/)?news\/./.test(location.pathname)) return;

    const meta = resolvePageMeta(location.pathname, lang);
    document.title = meta.title;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) descriptionTag.setAttribute("content", meta.description);
  }, [location.pathname, lang]);
}
